import { graphql } from '@teachino/shared-infrastructure';
import { topicListItemFragment } from '../folders/topic-list-item';
import { materialListItemFragment } from '../materials/material-list-item.fragment';

export const librarySearchQuery = graphql(
  `
    query LibrarySearch($search: String) {
      topics: searchContent(
        contentSearchInput: { search: $search, searchType: TOPIC }
      ) {
        ... on BaseModel {
          id
          __typename
        }
        ... on Folder {
          id
          ...TopicListItem
        }
        ... on Material {
          ...MaterialListItem
        }
      }
      materials: searchContent(
        contentSearchInput: { search: $search, searchType: MATERIAL }
      ) {
        ... on BaseModel {
          id
          __typename
        }
        ... on Folder {
          id
          ...TopicListItem
        }
        ... on Material {
          ...MaterialListItem
        }
      }
    }
  `,
  [topicListItemFragment, materialListItemFragment],
);
